import React, { useState } from 'react';
import { Flex, Stack, Text } from '@chakra-ui/layout';
import { Image, useToast } from '@chakra-ui/react';
import { Link, useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Input, Button, ColorfulBar } from '~/components';
import logo from '~/assets/logo-service-gray.png';
import { ROUTER_PATHS } from '~/constants';
import { checkUserByEmail } from '~/services/Users';
import api from '~/utils/api';
import { PrivacyPolicyFooter } from '~/components/PrivacyPolicyFooter';

const forgotPasswordFormSchema = yup.object().shape({
  email: yup.string().required('Email obrigatório').email('Email inválido'),
});

export const ForgotPassword: React.VFC = () => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(forgotPasswordFormSchema),
  });
  const { errors } = formState;

  const [sent, setSent] = useState<Boolean>(false);

  async function handleForgotPassword(formData: { email: string }) {
    try {
      setIsLoading(true);
      const response = await checkUserByEmail(formData);

      if (response?.data?.type === 'external') {
        api.post('/auth/forgot-password', formData).then(() => {
          setSent(true);
        });
      } else if (response?.data?.type === 'internal') {
        throw new Error('Usuários Internos não podem alterar a senha de rede');
      } else {
        throw new Error('E-mail não encontrado');
      }
    } catch (error: any) {
      setIsLoading(false);
      if (error?.response?.status === 400) {
        console.log(error.response.data.message);
        toast({
          title: error.response.data.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      } else {
        toast({
          title: error.message || 'E-mail não encontrado',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
    }
  }

  const handleBack = () => {
    history.replace(ROUTER_PATHS.LOGIN);
  };

  return (
    <Flex w="100vw" h="100vh" flexDir="column">
      <ColorfulBar />
      <Flex justify="center" p="2" pt={16} h="100%">
        <Flex flexDir="column" align="center">
          <Flex flexDir="column" align="center" maxW={300}>
            <Image src={logo} maxW="200px" mb="12" />
            {!sent ? (
              <Flex flexDir="column">
                <Text textAlign="center">
                  Informe seu e-mail para enviarmos as instruções de
                  recuperação.
                </Text>
                <Stack
                  as="form"
                  w={300}
                  gridGap="2"
                  mt="8"
                  onSubmit={handleSubmit(handleForgotPassword)}
                >
                  <Input
                    name="email"
                    type="email"
                    label="E-mail"
                    register={register}
                    error={errors.email}
                    isDisabled={isLoading}
                  />
                  <Button type="submit" isLoading={isLoading}>
                    Recuperar senha
                  </Button>
                  <Flex justify="right">
                    <Link to={ROUTER_PATHS.LOGIN}>
                      <Text fontSize="14px" color="gray.900">
                        Voltar para Login
                      </Text>
                    </Link>
                  </Flex>
                </Stack>
              </Flex>
            ) : (
              <Flex flexDir="column">
                <Text textAlign="center" color="gray.">
                  Verifique sua caixa de entrada para dar continuidade na
                  recuperação da senha.
                </Text>

                <Button mt={8} onClick={handleBack}>
                  Voltar para Login
                </Button>
              </Flex>
            )}
          </Flex>
          <PrivacyPolicyFooter isPortal={false} />
        </Flex>
      </Flex>
    </Flex>
  );
};
